module.exports = __webpack_public_path__ + "img/05.5a41daf3.png";